import React from 'react';
import { Dialog } from '@mui/material';
import DialogLayout from './components/DialogLayout';
import ReasonSelection from './components/ReasonSelection';
import UsageStats from './components/UsageStats';
import ConfirmCancellation from './components/ConfirmCancellation';
import useCancelAutoRenewDialog from './hooks/useCancelAutoRenewDialog';
import { STEPS } from './constants';
import { StyledCancelAutoRenewDialog } from './index.style';

const CancelAutoRenewDialog = ({
  open,
  packageExpiryDate,
  onClose,
  onSuccess,
}) => {
  const {
    currentStep,
    reset,
    selectedReason,
    otherReasonText,
    canProceedStep1,
    selectReason,
    handleOtherTextChange,
    usageStats,
    feedbackText,
    isSubmitting,
    handleFeedbackChange,
    setIsSubmitting,
    goToNextStep,
  } = useCancelAutoRenewDialog();

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleConfirm = () => {
    if (onSuccess) {
      onSuccess({
        cancelReason: selectedReason,
        cancelReasonOther: otherReasonText,
        cancelFeedback: feedbackText,
        setIsSubmitting,
        reset,
        onClose,
      });
    }
  };

  return (
    <Dialog
      open={open}
      fullScreen
      sx={{ zIndex: 1300 }}
      PaperProps={{ sx: { background: '#ffffff' } }}
    >
      <StyledCancelAutoRenewDialog>
        <DialogLayout onClose={handleClose}>
          {currentStep === STEPS.REASON_SELECTION && (
            <ReasonSelection
              selectedReason={selectedReason}
              otherReasonText={otherReasonText}
              canProceedStep1={canProceedStep1}
              onSelectReason={selectReason}
              onOtherTextChange={handleOtherTextChange}
              onContinue={goToNextStep}
            />
          )}
          {currentStep === STEPS.USAGE_STATS && (
            <UsageStats usageStats={usageStats} onContinue={goToNextStep} />
          )}
          {currentStep === STEPS.CONFIRM_CANCELLATION && (
            <ConfirmCancellation
              packageExpiryDate={packageExpiryDate}
              feedbackText={feedbackText}
              isSubmitting={isSubmitting}
              onFeedbackChange={handleFeedbackChange}
              onConfirm={handleConfirm}
            />
          )}
        </DialogLayout>
      </StyledCancelAutoRenewDialog>
    </Dialog>
  );
};

export default CancelAutoRenewDialog;
